/* Fine Foams cart drawer: "Complete the set" upsell add. Re-renders the drawer
   via Dawn's Section Rendering flow so the upsell list stays accurate. */
(function () {
  if (window.ffCartUpsellAdd) return;
  window.ffCartUpsellAdd = function (btn) {
    var id = parseInt(btn.getAttribute('data-ff-upsell-add'), 10);
    if (!id || btn.disabled) return;
    btn.disabled = true;
    var drawer = document.querySelector('cart-drawer');
    var line = { id: id, quantity: 1 };
    // The drawer's "Add my free gift" card marks its line like the PDP auto-add
    // does, so orphaned-gift cleanup can recognise it (see ff-product.js).
    if (btn.hasAttribute('data-ff-gift-flag')) line.properties = { _ff_gift: '1' };
    var body = { items: [line] };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw res;
        if (drawer && drawer.renderContents) drawer.renderContents(res);
      })
      .catch(function () {
        // Never navigate away — bouncing the shopper to /cart mid-interaction
        // was one source of the "it randomly opens the cart page" report.
        // Re-sync the drawer in place so it shows the true cart instead.
        var items = document.querySelector('cart-drawer-items');
        if (items && items.onCartUpdate) items.onCartUpdate();
      })
      .finally(function () { btn.disabled = false; });
  };
})();
